(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-camera-finder-v5-kameram10-auto"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFinder = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const quiz = root.querySelector('[data-quiz]');
      const result = root.querySelector('[data-result]');
      const resultCard = root.querySelector('[data-result-card]');
      const steps = Array.from(root.querySelectorAll('[data-step]'));
      const cards = Array.from(root.querySelectorAll('[data-camera-card]'));
      const backButton = root.querySelector('[data-back]');
      const restartButton = root.querySelector('[data-restart]');
      const progress = root.querySelector('[data-progress]');
      const progressText = root.querySelector('[data-progress-text]');
      const gift = root.querySelector('[data-gift]');
      const giftCodeElement = root.querySelector('[data-gift-code]');
      const copyGiftButton = root.querySelector('[data-copy-gift]');
      const applyGiftButton = root.querySelector('[data-apply-gift]');
      const giftStatus = root.querySelector('[data-gift-status]');

      if (!quiz || !result || !steps.length) return;


      const getRoutesRoot = () => {
        return window.Shopify?.routes?.root || '/';
      };

      const AUTO_DISCOUNT_CODE = 'KAMERAM10';

      const applyAutomaticDiscount = async () => {
        const response = await fetch(getRoutesRoot() + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ discount: AUTO_DISCOUNT_CODE })
        });

        if (!response.ok) {
          throw new Error('İndirim otomatik uygulanamadı');
        }

        return response.json();
      };

      const revealGift = () => {
        if (root.dataset.giftEnabled !== 'true' || !gift) return;
        gift.hidden = false;
        gift.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      const copyGiftCode = async () => {
        const code = giftCodeElement?.textContent?.trim();
        if (!code) return;

        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const textarea = document.createElement('textarea');
            textarea.value = code;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            textarea.remove();
          }

          if (copyGiftButton) {
            const original = copyGiftButton.textContent;
            copyGiftButton.textContent = 'Kopyalandı ✓';
            window.setTimeout(() => { copyGiftButton.textContent = original; }, 1800);
          }
        } catch (error) {
          if (giftStatus) giftStatus.textContent = 'Kod kopyalanamadı. Kodu seçerek manuel olarak kopyalayabilirsin.';
        }
      };

      const applyGiftAndOpenCart = async () => {
        const code = giftCodeElement?.textContent?.trim();
        if (!code || !applyGiftButton) return;

        const original = applyGiftButton.textContent;
        applyGiftButton.disabled = true;
        applyGiftButton.textContent = 'Kod uygulanıyor…';
        if (giftStatus) giftStatus.textContent = '';

        try {
          const response = await fetch(getRoutesRoot() + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ discount: code })
          });

          if (!response.ok) throw new Error('Discount could not be applied');
          window.location.href = getRoutesRoot() + 'cart';
        } catch (error) {
          applyGiftButton.disabled = false;
          applyGiftButton.textContent = original;
          if (giftStatus) giftStatus.textContent = 'Kod otomatik uygulanamadı. Kodu kopyalayıp sepette kullanabilirsin.';
        }
      };

      const insightMap = {
        use_case: {
          social: '🤳 Selfie ve vlog seçimin, kameranın yalnızca anı kaydeden bir cihaz değil; senin de o anın içinde olduğun, paylaşılabilir hikâyeler üretmenin bir yolu olmasını istediğini gösteriyor.',
          retro: '📸 Retro çekimleri seçtin. Kusursuz ve fazla steril görüntülerden çok, karakteri olan ve yıllar sonra baktığında sana o anın hissini geri getirecek kareler sana daha yakın.',
          quality: '✨ Görüntü kalitesini öne koydun. Senin için “çekmiş olmak” yeterli değil; görüntünün tekrar baktığında da etkileyici ve özenli görünmesini istiyorsun.',
          easy: '👜 Günlük kullanım senin için önemli. Kameranın özel bir günde raftan indirilen bir cihaz değil, spontane bir anda kolayca eline alabileceğin bir yol arkadaşı olmasını istiyorsun.',
          kids: '🎁 Bu kamerayı hediye veya eğlenceli kullanım için düşünüyorsun. Teknik detaylardan önce kolay anlaşılması, keyif vermesi ve kullanmaya başladığı anda güzel bir deneyim sunması önemli.'
        },
        size: {
          mini: '🔑 Mini boyutu seçmen, kamerayı yanında taşımak için plan yapmak istemediğini gösteriyor; çantanda, cebinde veya anahtarlığında hazır olması senin için değerli.',
          compact: '🎒 Kompakt yapıyı tercih ettin. Taşınabilirlikten vazgeçmeden gerçek bir kamera hissini korumak istiyorsun.',
          standard: '📷 Boyuttan çok kapasiteyi önemsiyorsun. Biraz daha güçlü bir model için daha büyük gövde senin açısından kabul edilebilir.'
        },
        screen: {
          flip: '🔄 Dönen ekran seçimin, selfie ve vlog sırasında kadrajı şansa bırakmak istemediğini gösteriyor. Çekimde kontrolün sende olması sana daha rahat hissettiriyor.',
          dual: '↔️ Çift ekran tercihin, kameranın hem önünde hem arkasında kullanım özgürlüğü istiyorsun demek; farklı çekim şekilleri arasında kolayca geçebilmek senin için önemli.',
          fixed: '▣ Standart ekranın yeterli olması, senin için asıl önceliğin ekran hareketinden çok çekimin kendisi olduğunu gösteriyor.'
        },
        wifi: {
          yes: '📱 Wi‑Fi aktarımı istemen, çektiğin görüntülerin kamerada beklemesini istemediğini gösteriyor. Telefonuna alıp hızlıca izlemek veya paylaşmak senin kullanım tarzına daha yakın.',
          no: '💾 Karttan aktarım senin için sorun değil. Kablosuz özellik yerine kameranın temel çekim deneyimine ve diğer özelliklerine daha fazla önem verebilirsin.'
        },
        budget: {
          budget: '💸 Fiyatı önceliklendirdin. Sana gerçekten kullanacağın özellikleri sunan, gereksiz özelliklere para ödetmeyen bir seçenek daha doğru hissettiriyor.',
          mid: '⚖️ Fiyat / performans dengesini seçtin. Hem iyi bir deneyim yaşamak hem de ödediğin tutarın karşılığını net biçimde almak istiyorsun.',
          premium: '🏆 Özellikleri fiyatın önüne koydun. Kamerayı aldıktan sonra “keşke daha iyisini seçseydim” dememek ve daha kapsamlı bir deneyim yaşamak senin için önemli.'
        }
      };

      const buildPersonalProfile = (clone, sourceCard) => {
        if (root.dataset.profileEnabled !== 'true') return;

        const profile = clone.querySelector('[data-profile]');
        const headline = clone.querySelector('[data-profile-headline]');
        const insights = clone.querySelector('[data-profile-insights]');
        const story = clone.querySelector('[data-camera-story]');
        const closing = clone.querySelector('[data-profile-closing]');
        const productTitle = clone.querySelector('.rr-camera-card__title')?.textContent?.trim() || 'bu kamera';

        if (!profile || !insights) return;
        profile.hidden = false;

        if (headline) {
          headline.textContent = sourceCard.dataset.resultHeadline || 'Bu seçim sana neden uyuyor? ✨';
        }

        insights.innerHTML = '';
        const insightOrder = ['use_case', 'screen', 'size', 'wifi', 'budget'];
        let added = 0;

        insightOrder.forEach((key) => {
          if (added >= 4) return;
          const answer = answers[key];
          if (!answer || answer === 'any') return;
          const message = insightMap[key]?.[answer];
          if (!message) return;

          const point = document.createElement('p');
          point.className = 'rr-camera-card__profile-point';
          point.textContent = message;
          insights.appendChild(point);
          added += 1;
        });

        const storyText = sourceCard.dataset.emotionalStory?.trim();
        if (story) {
          story.textContent = storyText || `Verdiğin cevapların ortak noktası, ${productTitle} modelini senin çekim alışkanlıklarınla güçlü biçimde eşleştiriyor.`;
          story.hidden = false;
        }

        if (closing) {
          const customClosing = sourceCard.dataset.emotionalClosing?.trim();
          closing.textContent = customClosing || `Kısacası: ${productTitle}, yalnızca teknik özellikleriyle değil, kamerayı nasıl kullanmak istediğinle de iyi eşleşiyor. 💫`;
        }
      };

      const weights = {
        use_case: 5,
        size: 3,
        screen: 3,
        wifi: 2,
        budget: 2
      };

      const datasetKeys = {
        use_case: 'useCase',
        size: 'size',
        screen: 'screen',
        wifi: 'wifi',
        budget: 'budget'
      };

      let currentStep = 0;
      let answers = {};

      const updateProgress = () => {
        const percent = ((currentStep + 1) / steps.length) * 100;
        if (progress) progress.style.width = `${percent}%`;
        if (progressText) progressText.textContent = `${currentStep + 1} / ${steps.length}`;
      };

      const showStep = (index) => {
        currentStep = Math.max(0, Math.min(index, steps.length - 1));

        steps.forEach((step, i) => {
          const active = i === currentStep;
          step.hidden = !active;
          step.classList.toggle('is-active', active);
        });

        if (backButton) backButton.hidden = currentStep === 0;
        updateProgress();
      };

      const scoreCard = (card) => {
        let score = Number(card.dataset.priority || 0) * 0.1;

        Object.entries(weights).forEach(([key, weight]) => {
          const answer = answers[key];
          const cardValue = card.dataset[datasetKeys[key]] || 'any';

          if (!answer) return;

          if (answer === 'any') {
            score += 0.15;
          } else if (cardValue === answer) {
            score += weight;
          } else if (cardValue === 'any') {
            score += weight * 0.2;
          }
        });

        return score;
      };

      const showResult = () => {
        if (!cards.length) {
          resultCard.innerHTML = '<p>Henüz önerilecek kamera eklenmemiş.</p>';
          quiz.hidden = true;
          result.hidden = false;
          return;
        }

        const ranked = cards
          .map((card, index) => ({ card, index, score: scoreCard(card) }))
          .sort((a, b) => {
            if (b.score !== a.score) return b.score - a.score;
            return a.index - b.index;
          });

        const winner = ranked[0]?.card;
        resultCard.innerHTML = '';

        if (winner) {
          const clone = winner.cloneNode(true);
          clone.removeAttribute('data-camera-card');
          clone.removeAttribute('data-use-case');
          clone.removeAttribute('data-size');
          clone.removeAttribute('data-screen');
          clone.removeAttribute('data-wifi');
          clone.removeAttribute('data-budget');
          clone.removeAttribute('data-priority');
          buildPersonalProfile(clone, winner);
          resultCard.appendChild(clone);
        }

        quiz.hidden = true;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };


      resultCard?.addEventListener('click', async (event) => {
        const addButton = event.target.closest('[data-add-to-cart]');
        if (!addButton || addButton.disabled) return;

        const variantId = Number(addButton.dataset.variantId);
        const status = addButton.closest('.rr-camera-card')?.querySelector('[data-cart-status]');
        const defaultLabel = addButton.dataset.defaultLabel || 'Sepete Ekle';

        if (!variantId) {
          if (status) status.textContent = 'Bu ürün sepete eklenemedi. Ürün sayfasından tekrar deneyebilirsin.';
          return;
        }

        addButton.disabled = true;
        addButton.textContent = 'Sepete ekleniyor…';
        if (status) status.textContent = '';

        try {
          const response = await fetch(getRoutesRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }]
            })
          });

          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Ürün sepete eklenemedi');
          }

          let discountedCart = null;
          try {
            discountedCart = await applyAutomaticDiscount();
          } catch (discountError) {
            console.warn('[Kamera Bulucu] KAMERAM10 indirimi otomatik uygulanamadı.', discountError);
          }

          addButton.textContent = 'Sepete Eklendi ✓';
          if (status) {
            status.textContent = discountedCart
              ? 'Harika seçim! Önerdiğimiz kamera sepetine eklendi.'
              : 'Ürün sepetine eklendi.';
          }

          document.dispatchEvent(new CustomEvent('rr:cart-updated', {
            detail: { source: 'camera-finder', item: data, cart: discountedCart }
          }));
        } catch (error) {
          addButton.disabled = false;
          addButton.textContent = defaultLabel;
          if (status) status.textContent = error.message || 'Ürün sepete eklenirken bir sorun oluştu.';
        }
      });

      copyGiftButton?.addEventListener('click', copyGiftCode);
      applyGiftButton?.addEventListener('click', applyGiftAndOpenCart);

      steps.forEach((step, stepIndex) => {
        const key = step.dataset.key;
        const buttons = step.querySelectorAll('[data-answer]');

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            answers[key] = button.dataset.answer;

            buttons.forEach((item) => item.classList.remove('is-selected'));
            button.classList.add('is-selected');

            if (stepIndex < steps.length - 1) {
              showStep(stepIndex + 1);
            } else {
              showResult();
            }
          });
        });
      });

      backButton?.addEventListener('click', () => {
        showStep(currentStep - 1);
      });

      restartButton?.addEventListener('click', () => {
        answers = {};
        resultCard.innerHTML = '';

        steps.forEach((step) => {
          step.querySelectorAll('[data-answer]').forEach((button) => {
            button.classList.remove('is-selected');
          });
        });

        if (gift) gift.hidden = true;
        if (giftStatus) giftStatus.textContent = '';
        result.hidden = true;
        quiz.hidden = false;
        showStep(0);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      showStep(0);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('.rr-camera-finder').forEach(initFinder);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-golens-gallery"] && !Shopify.designMode) return;
  try {
    
  function rrGoLensGalleries(root = document) {
    root.querySelectorAll('.rr-golens-gallery').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const dialog = gallery.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('img');
      gallery.querySelectorAll('[data-golens-shot]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          image.src = link.href;
          image.alt = link.querySelector('img').alt;
          dialog.showModal();
        });
      });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => image.removeAttribute('src'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => rrGoLensGalleries());
  else rrGoLensGalleries();
  document.addEventListener('shopify:section:load', (event) => rrGoLensGalleries(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-golens-story"] && !Shopify.designMode) return;
  try {
    
  function rrGoLensStoryVideos(root = document) {
    root.querySelectorAll('[data-golens-video-toggle]').forEach((button) => {
      if (button.dataset.videoReady) return;
      button.dataset.videoReady = 'true';
      const video = button.querySelector('[data-golens-video]');
      const source = video.querySelector('source');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let manualPaused = false;
      let explicitlyStarted = false;
      let disposed = false;
      const allowAutoplay = () => explicitlyStarted || (!reduceMotion.matches && !navigator.connection?.saveData);
      const play = () => {
        if (disposed || !visible || manualPaused || document.hidden || !allowAutoplay()) return;
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
          video.load();
        }
        video.muted = true;
        const pending = video.play();
        if (pending) pending.catch(() => {});
      };
      const sync = () => {
        if (visible && !manualPaused && !document.hidden && allowAutoplay()) play();
        else video.pause();
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          sync();
        });
      }, { threshold: [0, 0.25] }) : null;
      if (observer) observer.observe(button);
      button.addEventListener('click', () => {
        explicitlyStarted = true;
        if (video.paused) {
          manualPaused = false;
          visible = true;
          play();
        } else {
          manualPaused = true;
          video.pause();
        }
      });
      video.addEventListener('playing', () => button.setAttribute('aria-pressed', 'true'));
      video.addEventListener('pause', () => button.setAttribute('aria-pressed', 'false'));
      document.addEventListener('visibilitychange', sync);
      reduceMotion.addEventListener('change', sync);
      const unload = (event) => {
        if (!event.target.contains(button)) return;
        disposed = true;
        video.pause();
        observer?.disconnect();
        document.removeEventListener('visibilitychange', sync);
        reduceMotion.removeEventListener('change', sync);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => rrGoLensStoryVideos());
  else rrGoLensStoryVideos();
  document.addEventListener('shopify:section:load', (event) => rrGoLensStoryVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-kampanya-koleksiyonlari-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-campaign-v2')) {
    class RRCampaignV2 extends HTMLElement {
      connectedCallback() {
        if (this.dataset.rrReady === 'true') return;
        this.dataset.rrReady = 'true';

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-rr-panel]'));
        this.timers = Array.from(this.querySelectorAll('[data-rr-countdown]'));
        this.mediaQuery = window.matchMedia('(max-width: 990px)');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index));
        });

        this.syncPanelAccessibility();
        this.mediaQuery.addEventListener('change', () => this.syncPanelAccessibility());
        this.startCountdowns();
      }

      activateTab(tab) {
        const target = tab.dataset.rrTarget;

        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
          item.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active-mobile', panel.dataset.rrPanel === target);
        });

        this.syncPanelAccessibility();
      }

      handleTabKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        this.tabs[nextIndex].focus();
        this.activateTab(this.tabs[nextIndex]);
      }

      syncPanelAccessibility() {
        const isCompact = this.mediaQuery.matches;

        this.panels.forEach((panel) => {
          const isActive = panel.classList.contains('is-active-mobile');
          panel.setAttribute('aria-hidden', String(isCompact && !isActive));

          if ('inert' in panel) {
            panel.inert = isCompact && !isActive;
          }
        });
      }

      startCountdowns() {
        if (!this.timers.length) return;

        const updateAll = () => {
          const now = Date.now();
          let hasRunningTimer = false;

          this.timers.forEach((timer) => {
            if (timer.dataset.rrEnded === 'true') return;

            const deadline = new Date(timer.dataset.deadline).getTime();
            if (Number.isNaN(deadline)) {
              timer.hidden = true;
              return;
            }

            const distance = deadline - now;
            if (distance <= 0) {
              timer.dataset.rrEnded = 'true';
              timer.classList.add('is-ended');
              timer.innerHTML = '<small>Kampanya durumu</small><div class="rr-campaign-v2__countdown-ended">Süre doldu</div>';
              return;
            }

            hasRunningTimer = true;

            const days = Math.floor(distance / 86400000);
            const hours = Math.floor((distance / 3600000) % 24);
            const minutes = Math.floor((distance / 60000) % 60);
            const seconds = Math.floor((distance / 1000) % 60);

            const setValue = (selector, value) => {
              const node = timer.querySelector(selector);
              if (node) node.textContent = String(value).padStart(2, '0');
            };

            setValue('[data-days]', days);
            setValue('[data-hours]', hours);
            setValue('[data-minutes]', minutes);
            setValue('[data-seconds]', seconds);
          });

          return hasRunningTimer;
        };

        updateAll();

        this.countdownInterval = window.setInterval(() => {
          if (document.hidden) return;
          const hasRunningTimer = updateAll();
          if (!hasRunningTimer) {
            window.clearInterval(this.countdownInterval);
          }
        }, 1000);
      }

      disconnectedCallback() {
        if (this.countdownInterval) {
          window.clearInterval(this.countdownInterval);
        }
      }
    }

    customElements.define('rr-campaign-v2', RRCampaignV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-memorybeat-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-memorybeat')) {
    customElements.define('rr-memorybeat', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.form = this.querySelector('.rrmb__form');
        if (!this.form) return;
        this.initialized = true;
        this.messages = JSON.parse(this.querySelector('[data-rrmb-messages]').textContent);
        this.packages = Array.from(this.querySelectorAll('.rrmb__package input'));
        this.slots = Array.from(this.querySelectorAll('[data-rrmb-slot]'));
        this.submit = this.querySelector('[data-rrmb-submit]');
        this.submitLabel = this.querySelector('[data-rrmb-submit-label]');
        this.error = this.querySelector('[data-rrmb-error]');
        this.isSubmitting = false;
        this.lockableAreas = Array.from(this.querySelectorAll('.rrmb__packages, [data-rrmb-uploads], [data-rrmb-audio]'));
        this.lockableAreas.forEach(area => {
          const preventEditing = event => {
            if (!this.isSubmitting || event.key === 'Tab') return;
            event.preventDefault();
            event.stopImmediatePropagation();
          };
          ['click', 'keydown', 'drop', 'dragover'].forEach(type => area.addEventListener(type, preventEditing, true));
        });
        this.objectUrls = new Map();
        this.audioInput = this.querySelector('[data-rrmb-audio-file]');
        this.audioPlayer = this.querySelector('[data-rrmb-audio-preview]');
        this.audioInput.addEventListener('change', () => this.updateAudio());
        this.querySelector('[data-rrmb-audio-remove]').addEventListener('click', () => { if (this.isSubmitting) return; this.audioInput.value = ''; this.updateAudio(); this.audioInput.focus(); });
        this.packages.forEach(input => input.addEventListener('change', () => this.updatePackage()));
        this.slots.forEach(slot => {
          const input = slot.querySelector('[data-rrmb-file]');
          input.addEventListener('change', () => this.updateFile(slot));
          slot.querySelector('[data-rrmb-remove]').addEventListener('click', () => { if (this.isSubmitting) return; input.value = ''; this.updateFile(slot); input.focus(); });
        });
        this.querySelectorAll('.rrmb__color').forEach(link => link.addEventListener('click', event => {
          if (this.isSubmitting || link.hasAttribute('aria-current')) { event.preventDefault(); return; }
          if ((this.audioInput.files.length || this.slots.some(slot => slot.querySelector('input').files.length)) && !window.confirm(this.messages.colorWarning)) { event.preventDefault(); return; }
          const destination = new URL(link.href, window.location.href);
          const current = new URL(window.location.href);
          if (current.searchParams.has('preview_theme_id')) destination.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
          if (current.searchParams.get('view') === 'memorybeat') destination.searchParams.set('view', 'memorybeat');
          link.href = destination.href;
        }));
        const submitOrder = event => {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.isSubmitting) return;
          const selected = this.packages.find(input => input.checked);
          if (!selected || selected.dataset.available !== 'true') { event.preventDefault(); this.showError(this.messages.soldOut); return; }
          const activeSlots = this.slots.filter(slot => !slot.hidden);
          for (const slot of activeSlots) this.validateFile(slot);
          if (activeSlots.some(slot => !slot.querySelector('input').files.length || !slot.querySelector('input').checkValidity())) {
            event.preventDefault(); this.showError(this.messages.missing); this.form.reportValidity(); return;
          }
          if (!this.audioInput.disabled) {
            this.validateAudio();
            if (!this.audioInput.files.length || !this.audioInput.checkValidity()) {
              this.showError(this.messages.missingAudio); this.form.reportValidity(); return;
            }
          }
          if (!this.form.reportValidity()) return;
          this.audioPlayer.pause();
          this.isSubmitting = true;
          this.submittingPackage = selected;
          this.submittingFiles = new Map([...this.slots.map(slot => slot.querySelector('input')), this.audioInput].map(input => [input, input.files]));
          this.lockableAreas.forEach(area => {
            area.dataset.rrmbWasInert = String(area.hasAttribute('inert'));
            area.setAttribute('inert', '');
          });
          this.submit.disabled = true;
          this.submit.setAttribute('aria-busy', 'true');
          this.submitLabel.textContent = Number(selected.dataset.count) > 0 ? this.messages.uploading : this.messages.adding;
          try {
            HTMLFormElement.prototype.submit.call(this.form);
          } catch (error) {
            this.resetSubmission();
            this.showError(this.messages.submitError);
          }
        };
        this.submit.addEventListener('click', submitOrder);
        this.form.addEventListener('submit', submitOrder, true);
        this.pageShow = () => {
          this.resetSubmission();
          this.slots.forEach(slot => this.updateFile(slot));
          this.updateAudio();
          this.updatePackage();
        };
        window.addEventListener('pageshow', this.pageShow);
        this.updatePackage();
      }
      resetSubmission() {
        this.isSubmitting = false;
        this.submittingPackage = null;
        this.submittingFiles = null;
        this.lockableAreas.forEach(area => {
          if (area.dataset.rrmbWasInert === 'false') area.removeAttribute('inert');
          delete area.dataset.rrmbWasInert;
        });
        this.updatePackage();
      }
      updatePackage() {
        if (this.isSubmitting) {
          this.packages.forEach(input => { input.checked = input === this.submittingPackage; });
          return;
        }
        const selected = this.packages.find(input => input.checked);
        if (!selected) return;
        const count = Number(selected.dataset.count);
        const needsAudio = selected.dataset.audio === 'true';
        this.querySelector('[data-rrmb-audio]').hidden = !needsAudio;
        this.querySelector('[data-rrmb-audio-instruction]').disabled = !needsAudio;
        this.audioInput.disabled = !needsAudio;
        this.audioInput.required = needsAudio;
        if (needsAudio) this.validateAudio();
        else { this.audioInput.setCustomValidity(''); this.audioPlayer.pause(); }
        this.querySelector('[data-rrmb-variant]').value = selected.dataset.variant;
        this.querySelector('[data-rrmb-price]').textContent = selected.dataset.price;
        this.querySelector('[data-rrmb-uploads]').hidden = count === 0;
        this.querySelector('[data-rrmb-guide-one]').hidden = count !== 1;
        this.querySelector('[data-rrmb-guide-five]').hidden = count !== 5;
        this.querySelector('[data-rrmb-grid]').dataset.count = count;
        this.querySelector('[data-rrmb-instruction]').disabled = count === 0;
        this.slots.forEach(slot => {
          const active = Number(slot.dataset.rrmbSlot) <= count;
          const input = slot.querySelector('input');
          slot.hidden = !active; input.disabled = !active; input.required = active;
          if (!active) input.setCustomValidity('');
        });
        const available = selected.dataset.available === 'true';
        this.submit.disabled = !available;
        this.submit.removeAttribute('aria-busy');
        this.submitLabel.textContent = available ? this.messages.add : this.messages.soldOut;
        this.error.hidden = true;
      }
      validateFile(slot) {
        const input = slot.querySelector('input');
        const file = input.files[0];
        let message = '';
        if (file) {
          if (!/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name) || (file.type && !/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type))) message = this.messages.invalidType;
          else if (file.size > 10 * 1024 * 1024) message = this.messages.tooLarge;
          else if (!file.size) message = this.messages.emptyFile;
        }
        input.setCustomValidity(message);
        slot.querySelector('[data-rrmb-file-error]').textContent = message;
        input.setAttribute('aria-invalid', String(Boolean(message)));
        return !message;
      }
      updateFile(slot) {
        const input = slot.querySelector('input');
        if (this.isSubmitting) {
          input.files = this.submittingFiles.get(input);
          return;
        }
        const image = slot.querySelector('[data-rrmb-preview]');
        const oldUrl = this.objectUrls.get(input);
        if (oldUrl) { URL.revokeObjectURL(oldUrl); this.objectUrls.delete(input); }
        image.hidden = true; image.removeAttribute('src');
        const file = input.files[0];
        const valid = this.validateFile(slot);
        slot.querySelector('[data-rrmb-filename]').textContent = file ? file.name : '';
        slot.querySelector('[data-rrmb-remove]').hidden = !file;
        slot.querySelector('[data-rrmb-upload-action]').textContent = file ? this.messages.change : this.messages.select;
        slot.querySelector('.rrmb__upload-target').classList.toggle('has-file', Boolean(file));
        if (file && valid) {
          const url = URL.createObjectURL(file);
          this.objectUrls.set(input, url);
          image.onload = () => { image.hidden = false; };
          image.onerror = () => { image.hidden = true; };
          image.src = url;
        }
        this.error.hidden = true;
      }
      validateAudio() {
        const file = this.audioInput.files[0];
        let message = '';
        if (file) {
          if (!/\.(mp3|m4a|wav)$/i.test(file.name) || (file.type && !/^(audio\/(mpeg|mp3|mp4|m4a|x-m4a|wav|wave|x-wav|vnd.wave)|application\/octet-stream)$/i.test(file.type))) message = this.messages.invalidAudio;
          else if (file.size > 10 * 1024 * 1024) message = this.messages.audioTooLarge;
          else if (!file.size) message = this.messages.emptyAudio;
        }
        this.audioInput.setCustomValidity(message);
        this.audioInput.setAttribute('aria-invalid', String(Boolean(message)));
        this.querySelector('[data-rrmb-audio-error]').textContent = message;
        return !message;
      }
      updateAudio() {
        if (this.isSubmitting) {
          this.audioInput.files = this.submittingFiles.get(this.audioInput);
          return;
        }
        this.audioPlayer.pause();
        this.audioPlayer.removeAttribute('src');
        this.audioPlayer.load();
        this.audioPlayer.hidden = true;
        const oldUrl = this.objectUrls.get(this.audioInput);
        if (oldUrl) { URL.revokeObjectURL(oldUrl); this.objectUrls.delete(this.audioInput); }
        const file = this.audioInput.files[0];
        const valid = this.validateAudio();
        this.querySelector('[data-rrmb-audio-filename]').textContent = file ? file.name : '';
        this.querySelector('[data-rrmb-audio-remove]').hidden = !file;
        this.querySelector('[data-rrmb-audio-action]').textContent = file ? this.messages.change : this.messages.selectAudio;
        if (file && valid) {
          const url = URL.createObjectURL(file);
          this.objectUrls.set(this.audioInput, url);
          this.audioPlayer.src = url;
          this.audioPlayer.hidden = false;
        }
        this.error.hidden = true;
      }
      showError(message) { this.error.textContent = message; this.error.hidden = false; }
      disconnectedCallback() {
        this.audioPlayer?.pause();
        this.objectUrls?.forEach(url => URL.revokeObjectURL(url));
        if (this.pageShow) window.removeEventListener('pageshow', this.pageShow);
      }
    });
  }
  if (!customElements.get('rr-memorybeat-gallery')) {
    customElements.define('rr-memorybeat-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.galleryEvents) return;
        this.track = this.querySelector('[data-rrmb-gallery-track]');
        this.slides = Array.from(this.querySelectorAll('[data-rrmb-slide]'));
        if (!this.track || !this.slides.length) return;
        this.previous = this.querySelector('[data-rrmb-gallery-prev]');
        this.next = this.querySelector('[data-rrmb-gallery-next]');
        this.counter = this.querySelector('[data-rrmb-gallery-current]');
        this.index = 0;
        this.galleryEvents = new AbortController();
        const options = { signal: this.galleryEvents.signal };
        this.previous?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.galleryFrame);
          this.galleryFrame = requestAnimationFrame(() => this.syncGallery());
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          let target;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight') target = this.index + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') target = this.index + (rtl ? 1 : -1);
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = this.slides.length - 1;
          else return;
          event.preventDefault();
          this.goTo(target);
        }, options);
        this.galleryResize = new ResizeObserver(() => this.goTo(this.index, false));
        this.galleryResize.observe(this.track);
        this.syncGallery();
      }
      goTo(index, animate = true) {
        const target = Math.max(0, Math.min(this.slides.length - 1, index));
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const smooth = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target * this.track.clientWidth * direction, behavior: smooth ? 'smooth' : 'auto' });
      }
      syncGallery() {
        if (!this.track.clientWidth) return;
        this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth)));
        if (this.counter) this.counter.textContent = String(this.index + 1);
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
        this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.index)));
      }
      disconnectedCallback() {
        this.galleryEvents?.abort();
        this.galleryEvents = null;
        this.galleryResize?.disconnect();
        cancelAnimationFrame(this.galleryFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-retroplay-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-retro-story-video')) {
    customElements.define('rr-retro-story-video', class extends HTMLElement {
      connectedCallback() {
        if (this.videoCleanup) return;
        const video = this.querySelector('video');
        const button = this.querySelector('[data-story-video-toggle]');
        if (!video || !button) return;
        const state = { visible: false, userPaused: false, autoplayBlocked: false, manualSession: false, pending: false, wantPlay: false, requestId: 0 };
        const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const automaticAllowed = () => !motionPreference.matches && !(connection && connection.saveData);
        const syncButton = () => {
          button.setAttribute('aria-pressed', String(!video.paused));
          button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        };
        const stop = () => {
          state.requestId += 1;
          state.wantPlay = false;
          state.pending = false;
          state.manualSession = false;
          if (!video.paused) video.pause();
          syncButton();
        };
        const inView = () => {
          const rect = video.getBoundingClientRect();
          const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
          const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
          return rect.width > 0 && rect.height > 0 && (width * height) / (rect.width * rect.height) >= .35;
        };
        const start = (manual) => {
          if (document.hidden || state.pending || !this.isConnected) return;
          if (manual ? !inView() : !state.visible || state.userPaused || state.autoplayBlocked || !automaticAllowed()) return;
          if (!video.paused) return;
          const requestId = ++state.requestId;
          state.wantPlay = true;
          state.pending = true;
          state.manualSession = manual;
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.playsInline = true;
          const rejected = () => {
            if (requestId !== state.requestId) return;
            state.pending = false;
            state.wantPlay = false;
            state.manualSession = false;
            state.autoplayBlocked = true;
            syncButton();
          };
          try {
            Promise.resolve(video.play()).then(() => {
              if (requestId !== state.requestId) {
                if (!state.wantPlay && !video.paused) video.pause();
                return;
              }
              state.pending = false;
              if (document.hidden || !this.isConnected || !inView() || state.userPaused) stop();
              else syncButton();
            }).catch(rejected);
          } catch (error) {
            rejected();
          }
        };
        const reconcile = () => {
          if (document.hidden || !state.visible || state.userPaused) stop();
          else if (state.manualSession && (!video.paused || state.pending)) return;
          else if (automaticAllowed()) start(false);
          else stop();
        };
        const onPlay = () => {
          if (!state.wantPlay || document.hidden || !this.isConnected) stop();
          else syncButton();
        };
        const onPreference = () => {
          if (!automaticAllowed()) stop();
          else reconcile();
        };
        const onToggle = () => {
          if (!video.paused || state.pending) {
            state.userPaused = true;
            stop();
          } else {
            state.userPaused = false;
            state.autoplayBlocked = false;
            start(true);
          }
        };
        let observer;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= .5) state.visible = true;
              else if (!entry.isIntersecting || entry.intersectionRatio < .35) state.visible = false;
              reconcile();
            });
          }, { threshold: [0, .35, .5] });
          observer.observe(video);
        }
        const fallbackCheck = () => { if ((!video.paused || state.pending) && !inView()) stop(); };
        video.muted = true;
        video.defaultMuted = true;
        button.hidden = false;
        syncButton();
        button.addEventListener('click', onToggle);
        video.addEventListener('play', onPlay);
        video.addEventListener('pause', syncButton);
        document.addEventListener('visibilitychange', reconcile);
        if (motionPreference.addEventListener) motionPreference.addEventListener('change', onPreference);
        else if (motionPreference.addListener) motionPreference.addListener(onPreference);
        if (connection && connection.addEventListener) connection.addEventListener('change', onPreference);
        if (!observer) {
          window.addEventListener('scroll', fallbackCheck, { passive: true, capture: true });
          window.addEventListener('resize', fallbackCheck, { passive: true });
        }
        this.videoCleanup = () => {
          stop();
          if (observer) observer.disconnect();
          button.removeEventListener('click', onToggle);
          video.removeEventListener('play', onPlay);
          video.removeEventListener('pause', syncButton);
          document.removeEventListener('visibilitychange', reconcile);
          if (motionPreference.removeEventListener) motionPreference.removeEventListener('change', onPreference);
          else if (motionPreference.removeListener) motionPreference.removeListener(onPreference);
          if (connection && connection.removeEventListener) connection.removeEventListener('change', onPreference);
          window.removeEventListener('scroll', fallbackCheck, true);
          window.removeEventListener('resize', fallbackCheck);
        };
      }
      disconnectedCallback() {
        if (this.videoCleanup) this.videoCleanup();
        this.videoCleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-retroplay-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rr-retroplay-videos')) {
    customElements.define('rr-retroplay-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.videoCleanup) return;
        const track = this.querySelector('.rr-retro-videos__track');
        if (!track) return;
        const states = Array.from(this.querySelectorAll('video')).map((video) => ({
          video,
          button: video.parentElement.querySelector('[data-retro-video-toggle]'),
          visible: false,
          userPaused: false,
          autoplayBlocked: false,
          manualSession: false,
          pending: false,
          wantPlay: false,
          requestId: 0
        }));
        const stateByVideo = new Map(states.map((state) => [state.video, state]));
        const navigation = this.querySelector('.rr-retro-videos__navigation');
        const previous = this.querySelector('[data-video-previous]');
        const next = this.querySelector('[data-video-next]');
        const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const automaticAllowed = () => !motionPreference.matches && !(connection && connection.saveData);
        const syncButton = (state) => {
          if (!state.button) return;
          const playing = !state.video.paused;
          state.button.setAttribute('aria-pressed', String(playing));
          state.button.setAttribute('aria-label', playing ? state.button.dataset.pauseLabel : state.button.dataset.playLabel);
        };
        const stop = (state) => {
          state.requestId += 1;
          state.wantPlay = false;
          state.pending = false;
          state.manualSession = false;
          if (!state.video.paused) state.video.pause();
          syncButton(state);
        };
        const inView = (state) => {
          const rect = state.video.getBoundingClientRect();
          const trackRect = track.getBoundingClientRect();
          const width = Math.max(0, Math.min(rect.right, trackRect.right, window.innerWidth) - Math.max(rect.left, trackRect.left, 0));
          const height = Math.max(0, Math.min(rect.bottom, trackRect.bottom, window.innerHeight) - Math.max(rect.top, trackRect.top, 0));
          return rect.width > 0 && rect.height > 0 && (width * height) / (rect.width * rect.height) >= .35;
        };
        const start = (state, manual) => {
          if (document.hidden || state.pending || !this.isConnected) return;
          if (manual ? !inView(state) : !state.visible || state.userPaused || state.autoplayBlocked || !automaticAllowed()) return;
          if (!state.video.paused) return;
          const requestId = ++state.requestId;
          state.wantPlay = true;
          state.pending = true;
          state.manualSession = manual;
          state.video.muted = true;
          state.video.defaultMuted = true;
          state.video.loop = true;
          state.video.playsInline = true;
          const rejected = () => {
            if (requestId !== state.requestId) return;
            state.pending = false;
            state.wantPlay = false;
            state.manualSession = false;
            state.autoplayBlocked = true;
            syncButton(state);
          };
          try {
            const result = state.video.play();
            Promise.resolve(result).then(() => {
              if (requestId !== state.requestId) {
                if (!state.wantPlay && !state.video.paused) state.video.pause();
                return;
              }
              state.pending = false;
              if (document.hidden || !this.isConnected || !inView(state) || state.userPaused) stop(state);
              else syncButton(state);
            }).catch(rejected);
          } catch (error) {
            rejected();
          }
        };
        const reconcile = (state) => {
          if (document.hidden || !state.visible || state.userPaused) stop(state);
          else if (state.manualSession && (!state.video.paused || state.pending)) return;
          else if (automaticAllowed()) start(state, false);
          else stop(state);
        };
        const onPlay = (event) => {
          const state = stateByVideo.get(event.target);
          if (!state) return;
          if (!state.wantPlay || document.hidden || !this.isConnected) stop(state);
          else syncButton(state);
        };
        const onPause = (event) => {
          const state = stateByVideo.get(event.target);
          if (state) syncButton(state);
        };
        const onVisibility = () => states.forEach(reconcile);
        const onPreference = () => {
          if (!automaticAllowed()) states.forEach(stop);
          else states.forEach(reconcile);
        };
        const onToggle = (event) => {
          const button = event.target.closest('[data-retro-video-toggle]');
          if (!button || !this.contains(button)) return;
          const state = states.find((item) => item.button === button);
          if (!state) return;
          if (!state.video.paused || state.pending) {
            state.userPaused = true;
            stop(state);
          } else {
            state.userPaused = false;
            state.autoplayBlocked = false;
            start(state, true);
          }
        };
        const updateNavigation = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          navigation.hidden = maxScroll <= 2;
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maxScroll - 2;
        };
        const move = (direction) => {
          const card = track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'auto' });
        };
        const onPrevious = () => move(-1);
        const onNext = () => move(1);
        let observer;
        if ('IntersectionObserver' in window && states.length) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              const state = stateByVideo.get(entry.target);
              if (!state) return;
              if (entry.isIntersecting && entry.intersectionRatio >= .5) state.visible = true;
              else if (!entry.isIntersecting || entry.intersectionRatio < .35) state.visible = false;
              reconcile(state);
            });
          }, { threshold: [0, .35, .5] });
          states.forEach((state) => observer.observe(state.video));
        }
        const fallbackCheck = () => {
          if (!observer) states.forEach((state) => { if ((!state.video.paused || state.pending) && !inView(state)) stop(state); });
        };
        let resizeObserver;
        if ('ResizeObserver' in window) {
          resizeObserver = new ResizeObserver(updateNavigation);
          resizeObserver.observe(track);
        }
        states.forEach((state) => {
          state.video.muted = true;
          state.video.defaultMuted = true;
          if (state.button) state.button.hidden = false;
          syncButton(state);
        });
        this.addEventListener('play', onPlay, true);
        this.addEventListener('pause', onPause, true);
        this.addEventListener('click', onToggle);
        document.addEventListener('visibilitychange', onVisibility);
        if (motionPreference.addEventListener) motionPreference.addEventListener('change', onPreference);
        else if (motionPreference.addListener) motionPreference.addListener(onPreference);
        if (connection && connection.addEventListener) connection.addEventListener('change', onPreference);
        if (!observer) {
          window.addEventListener('scroll', fallbackCheck, { passive: true, capture: true });
          window.addEventListener('resize', fallbackCheck, { passive: true });
        }
        track.addEventListener('scroll', updateNavigation, { passive: true });
        previous.addEventListener('click', onPrevious);
        next.addEventListener('click', onNext);
        updateNavigation();
        this.videoCleanup = () => {
          states.forEach(stop);
          if (observer) observer.disconnect();
          if (resizeObserver) resizeObserver.disconnect();
          this.removeEventListener('play', onPlay, true);
          this.removeEventListener('pause', onPause, true);
          this.removeEventListener('click', onToggle);
          document.removeEventListener('visibilitychange', onVisibility);
          if (motionPreference.removeEventListener) motionPreference.removeEventListener('change', onPreference);
          else if (motionPreference.removeListener) motionPreference.removeListener(onPreference);
          if (connection && connection.removeEventListener) connection.removeEventListener('change', onPreference);
          window.removeEventListener('scroll', fallbackCheck, true);
          window.removeEventListener('resize', fallbackCheck);
          track.removeEventListener('scroll', updateNavigation);
          previous.removeEventListener('click', onPrevious);
          next.removeEventListener('click', onNext);
        };
      }
      disconnectedCallback() {
        if (this.videoCleanup) this.videoCleanup();
        this.videoCleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-sample-shots"] && !Shopify.designMode) return;
  try {
    
  function rrSampleGalleries(root = document) {
    root.querySelectorAll('.rr-sample-shots').forEach((section) => {
      if (section.dataset.galleryReady) return;
      const lightbox = document.getElementById(section.id.replace('rrSampleShots-', 'rrSampleLightbox-'));
      if (!lightbox) return;
      section.dataset.galleryReady = 'true';
      const image = lightbox.querySelector('.rr-sample-lightbox-img');
      const closeButton = lightbox.querySelector('.rr-sample-lightbox-close');
      let opener = null;
      let previousOverflow = '';
      const restore = () => {
        image.removeAttribute('src');
        document.body.style.overflow = previousOverflow;
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      };
      section.querySelectorAll('.rr-shot').forEach((shot) => {
        shot.addEventListener('click', () => {
          if (!shot.dataset.image || lightbox.open) return;
          if (typeof lightbox.showModal !== 'function') {
            window.location.assign(shot.dataset.image);
            return;
          }
          opener = shot;
          previousOverflow = document.body.style.overflow;
          image.src = shot.dataset.image;
          image.alt = shot.dataset.imageAlt;
          image.width = Number(shot.dataset.imageWidth) || 1600;
          image.height = Number(shot.dataset.imageHeight) || 1600;
          lightbox.showModal();
          document.body.style.overflow = 'hidden';
          closeButton.focus({ preventScroll: true });
        });
      });
      closeButton.addEventListener('click', () => lightbox.close());
      lightbox.querySelector('.rr-sample-lightbox-bg').addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('close', restore);
      const unload = (event) => {
        if (!event.target.contains(section)) return;
        if (lightbox.open) {
          lightbox.close();
          restore();
        }
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => rrSampleGalleries());
  else rrSampleGalleries();
  document.addEventListener('shopify:section:load', (event) => rrSampleGalleries(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-topbar-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-rr-topbar-v2]';

    const init = (root) => {
      if (!root || root.dataset.rrReady === 'true') return;
      root.dataset.rrReady = 'true';

      const messages = Array.from(root.querySelectorAll('[data-rr-message]'));
      const pauseButton = root.querySelector('[data-rr-pause]');
      const interval = Number(root.dataset.interval || 4000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (messages.length <= 1) return;

      let index = Math.max(0, messages.findIndex((message) => message.classList.contains('is-active')));
      let timer = null;
      let manuallyPaused = reduceMotion;
      let interactionPaused = false;

      const renderPauseState = () => {
        const paused = manuallyPaused || interactionPaused;
        root.dataset.paused = paused ? 'true' : 'false';

        if (pauseButton) {
          pauseButton.setAttribute('aria-label', manuallyPaused ? 'Duyuruları oynat' : 'Duyuruları duraklat');
        }
      };

      const show = (nextIndex) => {
        messages.forEach((message, messageIndex) => {
          const active = messageIndex === nextIndex;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        index = nextIndex;
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        renderPauseState();

        if (manuallyPaused || interactionPaused) return;

        timer = window.setInterval(() => {
          if (!root.isConnected) {
            stop();
            return;
          }
          show((index + 1) % messages.length);
        }, Math.max(interval, 2500));
      };

      messages.forEach((message, messageIndex) => {
        message.setAttribute('aria-hidden', messageIndex === index ? 'false' : 'true');
      });

      if (pauseButton) {
        pauseButton.addEventListener('click', () => {
          manuallyPaused = !manuallyPaused;
          start();
        });
      }

      root.addEventListener('mouseenter', () => {
        interactionPaused = true;
        start();
      });

      root.addEventListener('mouseleave', () => {
        interactionPaused = false;
        start();
      });

      root.addEventListener('focusin', () => {
        interactionPaused = true;
        start();
      });

      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) {
          interactionPaused = false;
          start();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      start();
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(selector)) init(scope);
      if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));

    document.addEventListener('shopify:block:select', (event) => {
      const message = event.target.closest('[data-rr-message]');
      const root = event.target.closest(selector);
      if (!message || !root) return;

      root.querySelectorAll('[data-rr-message]').forEach((item) => {
        const active = item === message;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      root.dataset.paused = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-topbar-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-rr-topbar-v2]';

    const init = (root) => {
      if (!root || root.dataset.rrReady === 'true') return;
      root.dataset.rrReady = 'true';

      const messages = Array.from(root.querySelectorAll('[data-rr-message]'));
      const interval = Number(root.dataset.interval || 4000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (messages.length <= 1) return;

      let index = Math.max(0, messages.findIndex((message) => message.classList.contains('is-active')));
      let timer = null;
      let interactionPaused = false;

      const show = (nextIndex) => {
        messages.forEach((message, messageIndex) => {
          const active = messageIndex === nextIndex;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        index = nextIndex;
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        stop();
        if (reduceMotion || interactionPaused) return;

        timer = window.setInterval(() => {
          if (!root.isConnected) {
            stop();
            return;
          }
          show((index + 1) % messages.length);
        }, Math.max(interval, 2500));
      };

      messages.forEach((message, messageIndex) => {
        message.setAttribute('aria-hidden', messageIndex === index ? 'false' : 'true');
      });

      root.addEventListener('mouseenter', () => {
        interactionPaused = true;
        start();
      });

      root.addEventListener('mouseleave', () => {
        interactionPaused = false;
        start();
      });

      root.addEventListener('focusin', () => {
        interactionPaused = true;
        start();
      });

      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) {
          interactionPaused = false;
          start();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      start();
    };

    const initAll = (scope = document) => {
      if (scope.matches && scope.matches(selector)) init(scope);
      if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));

    document.addEventListener('shopify:block:select', (event) => {
      const message = event.target.closest('[data-rr-message]');
      const root = event.target.closest(selector);
      if (!message || !root) return;

      root.querySelectorAll('[data-rr-message]').forEach((item) => {
        const active = item === message;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

    });
  })();

  } catch(e) { console.error(e); }
})();
})();
